import React from "react";
import "../style/Home.css";
import { Container } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";
// import CFILinePlot from "./CFILinePlot";
// import ReactPlayer from 'react-player';
import ListGroup from 'react-bootstrap/ListGroup';
import AddFeedback from "./AddFeedback";
import DelFeedback from "./DelFeedback";
import CFIScatterPlot from "./CFIScatterPlot";
import { apiFetchJson } from "../api";


const GetPlotData = (study, focusTraineeID, plotType) => {
    const dataList = [];
    study.trainee_ids.forEach((trainee_id, index) => {
        const traineeName = study.traineeNames[index];
        const plotData = {
            xArray: [],
            yArray: [], 
            trainee_id: trainee_id,
            xLabel: 'Simulation Number',
            yLabel: plotType === 'Q' ? 'Flow (0.0-1.0)' : 'Time Taken (mins)',
            dataLabel: traineeName,
            color: focusTraineeID === 'ALL' ? null : parseInt(trainee_id) === parseInt(focusTraineeID) ? '#F02424' : '#979799',
            step: plotType === 'Q' ? 0.2 : 5.0,
        };
        dataList.push(plotData);
    });

    study.simulations.forEach(simulation => {
        const thisTraineeID = simulation.trainee_id;
        const thisPlotData = dataList.find(data => data.trainee_id === thisTraineeID);  
        const parts = simulation.simulationID.split('-');
        const simNumber = parseInt(parts[parts.length - 1], 10);
        thisPlotData.xArray.push(simNumber);
        const data = simulation.meta;
        if (data) {
            if (plotType === 'Q') {
                thisPlotData.yArray.push(data.Q);
            } else if (plotType === 'T') {
                if (data.time_taken > 1.0) { // So we are not plotting 0 values (no time)
                thisPlotData.yArray.push(data.time_taken);
            } else {
                    thisPlotData.yArray.push(null);
                }
            }
        } else {
            thisPlotData.yArray.push(null);
        }
    });
    return dataList;
}


const SupervisorAssessmentResults = ({ study, supervisor, filterTraineeID }) => {

    const [traineeSims, setTraineeSims] = useState(undefined);
    const [traineeFeedbacks, setTraineeFeedbacks] = useState(undefined);
    // const [status, setStatus] = useState('--');
    // const [message, setMessage] = useState('');

    const [addImprovement, setAddImprovement] = useState(false);
    const [addProblem, setAddProblem] = useState(false);
    const [addFeedback, setAddFeedback] = useState(false);

    const [showDelFB, setShowDelFB] = useState(false);
    const [activeFB, setActiveFB] = useState(undefined);
    const handleShow = (fbID) => {
        setActiveFB(fbID);
    }
    useEffect(() => {
        activeFB && setShowDelFB(true);
    }, [activeFB]);

    function refresh() {
        apiFetchJson('/api/getTraineeSimulations/' + filterTraineeID + '/' + study.studyID).then(data => {
            setTraineeSims(Array.isArray(data?.db) ? data.db : []);
            // setStatus(data.status);
            // setMessage(data.message);
            // console.log('TraineeSims', data.db)
        }).then(() => {
            apiFetchJson('/api/getTraineeFeedbacks/' + filterTraineeID + '/' + study.studyID).then(data => {
            setTraineeFeedbacks(Array.isArray(data?.db) ? data.db : []);
            // setStatus(data.status);
            // setMessage(data.message);
            // console.log('TraineeFeedbacks', data.db)
            });
        })
        .catch(error => {
            console.log(error);
        })
        
    }
    // TODO : if error - show toast

    useEffect(() => {
        refresh();
    }, []);
    useEffect(() => {
        refresh();
    }, [addProblem, addImprovement, addFeedback, showDelFB]);

    function clickAddImprovement() {
        setAddImprovement(true);
    };
    function clickAddProblem() {
        setAddProblem(true);
    };
    function clickAddFeedback() {
        setAddFeedback(true);
    };

    return (
        <Container>
            {traineeSims && traineeFeedbacks &&
                <Row>
                    <AddFeedback study={study} supervisor={supervisor} traineeID={filterTraineeID} feedbackType="Problem" open={addProblem} onClose={() => setAddProblem(false)}></AddFeedback>
                    <AddFeedback study={study} supervisor={supervisor} traineeID={filterTraineeID} feedbackType="Improvement" open={addImprovement} onClose={() => setAddImprovement(false)}></AddFeedback>
                    <AddFeedback study={study} supervisor={supervisor} traineeID={filterTraineeID} feedbackType="Feedback" open={addFeedback} onClose={() => setAddFeedback(false)}></AddFeedback>

                    <Row>   
                        <Col>   
                            <CFIScatterPlot dataList={GetPlotData(study, filterTraineeID, 'Q')} />
                        </Col>
                        <Col>
                            <CFIScatterPlot dataList={GetPlotData(study, filterTraineeID, 'T')} />
                        </Col>
                    </Row>

                    {/* <Row>  TODO IF MOVIE SUMMARY BECOMES A THING
                        {traineeSims.map(
                            (iSimulation) =>
                                iSimulation.simulationMovieFilename && (
                                    <div>
                                        <Row>
                                            <ReactPlayer
                                                url={'/api/download/trainee/' + iSimulation.id + '/MOVSUMMARY'}
                                                controls={true}
                                                className='border border-dark'>
                                            </ReactPlayer>
                                        </Row>
                                        <Row>
                                            <figcaption>{iSimulation.traineeName + " " + iSimulation.simulationID}</figcaption>
                                        </Row>
                                    </div>
                                )
                        )}
                    </Row> */}
                    <Row>
                        <Col className="border border rounded-2 m-3">
                            <Row>
                                <Col>
                                    <h4>Review</h4>
                                </Col>
                                <Col>
                                    <Button size="sm" onClick={clickAddProblem}>Add</Button>
                                </Col>
                            </Row>
                            <Row>
                                <ListGroup>
                                    {traineeFeedbacks.map(
                                        (iFeedback) => 
                                            iFeedback.feedbackType === 'Problem' &&
                                            <ListGroup.Item key={"Problem"+iFeedback.id} action onClick={() => handleShow(iFeedback.id)}>
                                                {iFeedback.feedbackText}
                                            </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Row>
                        </Col>
                        <Col className="border border rounded-2 m-3">
                            <Row>
                                <Col>
                                    <h4>Comments</h4>
                                </Col>
                                <Col>
                                    <Button size="sm" onClick={clickAddImprovement}>Add</Button>
                                </Col>
                            </Row>
                            <Row>
                                <ListGroup>
                                    {traineeFeedbacks.map(
                                        (iFeedback) => 
                                            iFeedback.feedbackType === 'Improvement' &&
                                            <ListGroup.Item key={"Improvement"+iFeedback.id} action onClick={() => handleShow(iFeedback.id)}>
                                                {iFeedback.feedbackText}
                                                </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Row>
                        </Col>
                        <Col className="border border rounded-2 m-3">
                            <Row>
                                <Col>
                                    <h4>Suggestions</h4>
                                </Col>
                                <Col>
                                    <Button size="sm" onClick={clickAddFeedback}>Add</Button>
                                </Col>
                            </Row>
                            <Row>
                                <ListGroup>
                                    {traineeFeedbacks.map(
                                        (iFeedback) => 
                                            iFeedback.feedbackType === 'Feedback' &&
                                            <ListGroup.Item key={"Feedback"+iFeedback.id} action onClick={() => handleShow(iFeedback.id)}>
                                                {iFeedback.feedbackText}
                                            </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Row>
                        </Col>
                        <DelFeedback feedbackID={activeFB} open={showDelFB} onClose={() => setShowDelFB(false)}></DelFeedback>
                    </Row>
                </Row>
            }
        </Container>
    );
}

export default SupervisorAssessmentResults;